<input
    type="text"
    class="form-control"
    #datePicker
    bsDaterangepicker
    [placeholder]="placeholder()"
    [bsValue]="lastDates"
    (bsValueChange)="setDate($event)"
    [bsConfig]="bsConfig()" />
